import { Card, CardInner } from "toddlar-ui";

const SkeletonCard: React.FC = () => (
  <Card>
    <CardInner>
      <div className="relative">
        <div className="aspect-square w-full overflow-hidden rounded-2xl bg-sand-200" />
        <div className="absolute inset-0 animate-pulse rounded-2xl bg-white/30" />
      </div>
      <div className="mt-4 space-y-2">
        <div className="h-4 w-2/3 rounded bg-sand-200" />
        <div className="h-3 w-full rounded bg-sand-200" />
        <div className="h-3 w-3/4 rounded bg-sand-200" />
        <div className="h-5 w-20 rounded-full bg-sand-200" />
      </div>
    </CardInner>
  </Card>
);

export default SkeletonCard;
